import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { ChakraProvider } from "@chakra-ui/react";
import "./styles/style.css";
import "./styles/datepicker.css";
import { getTheme } from "./theme";
import { isLightTheme, isSquareCorners } from "./hooks/useThemeMode";
import Main from "./Main";

async function startApp() {
  await import("./i18n");

  // ?theme=light flattens the input borders; ?button_style=square squares the
  // buttons. The two are independent. These params only appear on the mailing
  // list and unsubscribe URLs, so building the theme once here is enough.
  const theme = getTheme({ light: isLightTheme(), square: isSquareCorners() });

  ReactDOM.render(
    <Suspense fallback={<div>Loading...</div>}>
      <ChakraProvider theme={theme}>
        <Main />
      </ChakraProvider>
    </Suspense>,
    document.getElementById("root")
  );
}

startApp();
